import { render, staticRenderFns } from "./AssignKpis.vue?vue&type=template&id=b9ea1718&scoped=true&"
import script from "./AssignKpis.vue?vue&type=script&lang=js&"
export * from "./AssignKpis.vue?vue&type=script&lang=js&"
import style0 from "./AssignKpis.vue?vue&type=style&index=0&id=b9ea1718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ea1718",
  null
  
)

export default component.exports